// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1792":"f4ce4f4e","3504":"ea4b7e59","4907":"c8785278","5403":"cf2a6492","5508":"2b600452","7589":"9d29626c","9828":"df41f87d"}[chunkId] + ".chunk.css";
};